module.exports = __webpack_public_path__ + "media/images/vyskovmapa26.11desktop-b61dbb31.svg";